import { reactive } from 'vue'

export const LayoutStore = reactive({
    isMobile: () => {
        return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
    }
})